import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Center, Spinner, Stack } from "@chakra-ui/react";

import { RoutesMap } from "../../routes.tsx";
import { useGetLimitQuery } from "../../api/limit";
import { useGetProfileQuery } from "../../api/profile";
import { PageHeader } from "../../components/shared/PageHeader";
import { SbpTransferPageContent } from "../../components/features/SbpTransfer";
import { useSbpTransferAllowed } from "../../components/features/SbpTransfer/hooks";

export const SbpTransferPage: FC = () => {
  const navigate = useNavigate();

  const { isPending: isProfilePending } = useGetProfileQuery();
  const { data: limit, isFetching: isLimitFetching } = useGetLimitQuery();

  const sbpTransferAllowed = useSbpTransferAllowed();
  const showSbpTransfer = !!limit?.status && sbpTransferAllowed && limit.status === "ACTIVE";

  useEffect(() => {
    if (!isProfilePending && !isLimitFetching && !showSbpTransfer) {
      navigate(RoutesMap.index);
    }
  }, [isProfilePending, isLimitFetching, showSbpTransfer]);

  if (isProfilePending || isLimitFetching) {
    return (
      <Center h="100svh" flex="1" pb="100px">
        <Spinner />
      </Center>
    );
  }

  if (!showSbpTransfer) {
    return null;
  }

  return (
    <Stack spacing={0} minH="100svh">
      <PageHeader title="Перевести" />

      <SbpTransferPageContent />
    </Stack>
  );
};
